import { createContext, useContext, type ReactNode } from 'react';
import type { OrganizationSettingsApi } from './types';

const OrganizationSettingsApiContext = createContext<OrganizationSettingsApi | null>(null);

/** Supplies the workspace-settings / masters / geo hooks from the host app's store. */
export function OrganizationSettingsApiProvider({
  value,
  children,
}: {
  value: OrganizationSettingsApi;
  children: ReactNode;
}) {
  return (
    <OrganizationSettingsApiContext.Provider value={value}>
      {children}
    </OrganizationSettingsApiContext.Provider>
  );
}

export function useOrganizationSettingsApi(): OrganizationSettingsApi {
  const api = useContext(OrganizationSettingsApiContext);
  if (!api) {
    throw new Error('OrganizationSettings must be wrapped in OrganizationSettingsApiProvider');
  }
  return api;
}
